module.exports = __webpack_public_path__ + "static/media/CV.45490661.pdf";